import { ValidationResponseEnum } from "../Enums/ValidationResponseEnum";
import { ValidationMessageEnum } from "../Enums/ValidationMessageEnum";
import { LogEnum } from "../Enums/LogEnum";
import IValidator from "./IValidator";
import { SDKConfiguraitonModel } from "../../../models";
import CookieTokenValidationModel from "../Models/CookieTokenValidationModel";
import { CookieTokenType } from "../Types/ConfiguratorTypes";

export default class CookieTokenValidator implements IValidator {
  private readonly keys = ["name", "requestHeaders"];
  private readonly isServerSide = typeof document === "undefined";

  validate(config: SDKConfiguraitonModel): CookieTokenValidationModel {
    if (!config.cookieToken) {
      const validation = new CookieTokenValidationModel();

      validation.message = { type: null, text: null };
      validation.validation = ValidationResponseEnum.VALID_VALUE;

      return validation;
    }

    let validation = this.validateCookieToken(config.cookieToken);
    validation = this.validateCookieTokenConfigFields(
      config.cookieToken,
      validation
    );
    validation = this.generateCookieTokenConfigMessages(validation);
    validation = this.checkCookieTokenConfigMessagesForErrors(validation);

    return validation;
  }

  private validateCookieToken = (cookieToken: CookieTokenType) => {
    const validationModel = new CookieTokenValidationModel();
    validationModel.message = { type: null, text: null };
    const authProviderConfigKeys = Object.keys(cookieToken);
    const incorrectKeys = authProviderConfigKeys.filter(
      (key: string) => !this.keys.includes(key)
    );

    if (incorrectKeys.length > 0) {
      validationModel.validation = ValidationResponseEnum.INVALID_VALUE;
      validationModel.message.type = LogEnum.WARNING;
      validationModel.message.text = `${
        ValidationMessageEnum.COOKIE_TOKEN_CONFIG_INVALID_PROP
      } ${incorrectKeys.join(",")}`;
    } else {
      validationModel.validation = ValidationResponseEnum.VALID_VALUE;
    }

    return validationModel;
  };

  private validateCookieTokenConfigFields = (
    cookieToken: CookieTokenType,
    validation: CookieTokenValidationModel
  ): any => {
    this.keys.forEach((key: string) => {
      if (cookieToken[key]) {
        validation[key].validation = ValidationResponseEnum.VALID_VALUE;
      } else {
        // We don't need to validate the requestHeaders on the client side
        if (key === "requestHeaders" && !this.isServerSide) {
          validation[key].validation = ValidationResponseEnum.VALID_VALUE;
        } else {
          validation[key].validation = ValidationResponseEnum.MISSING_VALUE;
        }
      }
    });

    return validation;
  };

  private generateCookieTokenConfigMessages = (
    validation: CookieTokenValidationModel
  ): any => {
    Object.keys(validation)
      .filter((key: string) => key !== "validation" && key !== "message")
      .forEach((key: string) => {
        const obj = validation[key];

        if (obj.validation === ValidationResponseEnum.MISSING_VALUE) {
          obj.message.text = `${ValidationMessageEnum.COOKIE_TOKEN_CONFIG_PROP_MISSING} ${key}`;
          obj.message.type = LogEnum.ERROR;
        }
      });

    return validation;
  };

  private checkCookieTokenConfigMessagesForErrors = (
    validation: CookieTokenValidationModel
  ) => {
    Object.keys(validation)
      .filter((key: string) => key !== "validation" && key !== "message")
      .forEach((key: string) => {
        const obj = validation[key];

        if (obj.validation === ValidationResponseEnum.MISSING_VALUE) {
          validation.validation = ValidationResponseEnum.INVALID_VALUE;
          validation.message.type = LogEnum.ERROR;

          validation.message.text =
            ValidationMessageEnum.COOKIE_TOKEN_CONFIG_MISSING_CONFIG;
        }
      });

    return validation;
  };
}
